import React from "react";

import "./loadingSpinner.scss";

/**
 * LoadingSpinner component used across the app.
 * 
 * Props:
 */
const LoadingSpinner = (props) => {
    return (
        <div className="spinner-container">
            <div className="spinner">
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
            </div>
        </div>
    );
};
export default LoadingSpinner;
